export default __webpack_public_path__ + "91b1966e761a8e0c0b83450f676e8fe4.png";